import React from "react";

import "./PerformanceSummary.css";

import {
    Flame,
    Trophy,
    Activity,
    Star
} from "lucide-react";

const PerformanceSummary = ({

    data,

    dashboard

}) => {

    const summary =
        data?.summary || {};

    const cards = [

        {

            title: "Current Streak",

            value:
                summary.currentStreak || 0,

            suffix: " Days",

            icon: <Flame size={28} />,

            color: "#EF4444"

        },

        {

            title: "Current Level",

            value:
                summary.currentLevel || 1,

            icon: <Trophy size={28} />,

            color: "#F59E0B"

        },

        {

            title: "Assessments",

            value:
                dashboard?.totalTestsCompleted ??
                summary.totalTestsCompleted ??
                0,

            icon: <Activity size={28} />,

            color: "#2563EB"

        },

        {

            title: "Total XP",

            value:
                summary.totalXP || 0,

            icon: <Star size={28} />,

            color: "#10B981"

        }

    ];

    return (

        <div className="performance-summary">

            <div className="performance-header">

                <h2>

                    Performance Summary

                </h2>

                <p>

                    Your current Ignite performance.

                </p>

            </div>

            <div className="performance-grid">

                {

                    cards.map(

                        (item, index) => (

                            <div

                                key={index}

                                className="performance-card"

                            >

                                <div

                                    className="performance-icon"

                                    style={{

                                        background:
                                            item.color

                                    }}

                                >

                                    {

                                        item.icon

                                    }

                                </div>

                                <span>

                                    {

                                        item.title

                                    }

                                </span>

                                <h3>

                                    {

                                        item.value

                                    }

                                    {

                                        item.suffix || ""

                                    }

                                </h3>

                            </div>

                        )

                    )

                }

            </div>

        </div>

    );

};

export default PerformanceSummary;